import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule } from '@angular/material/bottom-sheet'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { ClientActions } from '@monorepo-channels/channels/domain'
import { Store } from '@ngrx/store'

@Component({
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatBottomSheetModule, MatIconModule],
	selector: 'feature-porto-bank-exit',
	styles: [
		`
			body.all {
				:host {
					--content-txt: #3c3c3c;
				}
			}
		`,
	],
	template: `
		<section
			style="padding: 16px; display: flex; flex-direction: column; align-items: flex-start; gap: 16px;"
		>
			<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
				<mat-icon svgIcon="porto-bank-icons:alert"></mat-icon>

				<mat-icon
					svgIcon="porto-bank-icons:close-circle"
					(click)="dialogRef?.close()"
					style="cursor: pointer;"
				></mat-icon>
			</div>

			<h1 style="font-size: 22px; font-weight: 600; color: #000; width: 220px">
				Deseja mesmo sair da sua conta?
			</h1>

			<div style="display: flex; gap: 8px; align-self: flex-end; margin-top: 16px;">
				<button
					mat-button
					(click)="dialogRef?.close()"
					style="background-color: transparent; color: var(--content-primary); font-weight: 600; font-size: 15px; max-width: 55px; height: 30px; border: 1px solid var(--content-primary);"
				>
					Não
				</button>

				<button
					mat-button
					(click)="logout()"
					style="background-color: var(--content-primary); color: white; font-weight: 600; font-size: 15px; max-width: 55px; height: 30px"
				>
					Sim
				</button>
			</div>
		</section>
	`,
})
export class ExitComponent {
	private store = inject(Store)
	public data: { client: string } =
		inject(MAT_DIALOG_DATA, { optional: true }) ?? inject(MAT_BOTTOM_SHEET_DATA, { optional: true })
	public dialogRef = inject(MatDialogRef<ExitComponent>, { optional: true })

	logout() {
		this.dialogRef?.close()
		this.store.dispatch(ClientActions.logoutClient())
	}
}
